/**
 * Semafor akvizície / dopytu (cust020) – pevný katalóg + merge s API (crm_states).
 * sort_order zodpovedá pôvodnej migrácii (plan_ok=1, …).
 */

export const CRM_ACQUISITION_SEMAPHORE_CATALOG = Object.freeze([
  { code: 'plan_ok', sortOrder: 1, color: '#16a34a', labelKey: 'CrmCommunication.Semaphore.Acquisition.plan_ok' },
  { code: 'suspended', sortOrder: 2, color: '#f59e0b', labelKey: 'CrmCommunication.Semaphore.Acquisition.suspended' },
  { code: 'problem', sortOrder: 3, color: '#dc2626', labelKey: 'CrmCommunication.Semaphore.Acquisition.problem' },
]);

export const CRM_QUOTE_SEMAPHORE_CATALOG = Object.freeze([
  { code: 'inquiry', sortOrder: 1, color: '#2563eb', labelKey: 'CrmCommunication.Semaphore.Quote.inquiry' },
  { code: 'in_progress', sortOrder: 2, color: '#f59e0b', labelKey: 'CrmCommunication.Semaphore.Quote.decision' },
  { code: 'offer', sortOrder: 3, color: '#16a34a', labelKey: 'CrmCommunication.Semaphore.Quote.offer' },
]);

function catalogForTicketType(ticketType) {
  return ticketType === 'acquisition' ? CRM_ACQUISITION_SEMAPHORE_CATALOG : CRM_QUOTE_SEMAPHORE_CATALOG;
}

export function semaphoreCatalogEntryForSortOrder(ticketType, sortOrder) {
  const order = Number(sortOrder);
  return catalogForTicketType(ticketType).find((e) => e.sortOrder === order) || null;
}

export function semaphoreCatalogEntryForCode(ticketType, code) {
  const key = String(code || '').trim().toLowerCase();
  return catalogForTicketType(ticketType).find((e) => e.code === key) || null;
}

/**
 * @param {Array<Record<string, unknown>>} apiDefs
 * @param {'acquisition'|'quote_request'} ticketType
 * @param {(key: string) => string} t
 */
export function buildSemaphoreStateOptions(apiDefs, ticketType, t) {
  const catalog = catalogForTicketType(ticketType);
  const apiRows = Array.isArray(apiDefs) ? apiDefs : [];

  return catalog
    .map((entry) => {
      const apiRow = apiRows.find((r) => Number(r?.sort_order) === entry.sortOrder) || null;
      if (!apiRow?.id) return null;
      return {
        label: t(entry.labelKey),
        value: String(apiRow.id),
        row: {
          ...apiRow,
          legacy_code: entry.code,
          color: apiRow.color || entry.color.replace(/^#/, ''),
        },
      };
    })
    .filter(Boolean);
}

/**
 * @param {Record<string, unknown>|null|undefined} state
 * @param {'acquisition'|'quote_request'} ticketType
 * @param {(key: string) => string} t
 * @param {string} [locale]
 * @param {(name: unknown, locale?: string) => string} [displayName]
 */
export function semaphoreLabelFromState(state, ticketType, t, locale, displayName) {
  if (!state || typeof state !== 'object') return '';
  if (typeof displayName === 'function') {
    const fromDb = displayName(state.name, locale);
    if (fromDb) return fromDb;
  }
  const entry = semaphoreCatalogEntryForSortOrder(ticketType, state.sort_order);
  if (entry) return t(entry.labelKey);
  return '';
}

/**
 * @param {string} label
 * @param {'acquisition'|'quote_request'} ticketType
 * @param {string} [fallbackHex]
 */
export function semaphoreColorFromLabel(label, ticketType, fallbackHex) {
  const normalized = String(label || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();
  if (ticketType === 'acquisition') {
    if (normalized === 'bezi podla planu') return '#16a34a';
    if (normalized === 'pozastavena') return '#f59e0b';
    if (normalized === 'problemova') return '#dc2626';
  } else {
    if (normalized === 'dopyt') return '#2563eb';
    if (normalized === 'rozhodovanie' || normalized === 'v rieseni') return '#f59e0b';
    if (normalized === 'ponuka') return '#16a34a';
  }
  return fallbackHex || '#6b7280';
}

export function semaphoreColorFromState(state, ticketType, fallbackHex) {
  if (!state) return fallbackHex || '#6b7280';
  const entry = semaphoreCatalogEntryForSortOrder(ticketType, state.sort_order);
  if (entry) return entry.color;
  const raw = state.color;
  if (raw) {
    const s = String(raw).trim();
    return s.startsWith('#') ? s : `#${s}`;
  }
  return fallbackHex || '#6b7280';
}
